import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import '@rainbow-me/rainbowkit/styles.css';
import img2 from './Components/Image/img2.png'
import {
  getDefaultConfig,
  RainbowKitProvider,
  lightTheme
} from '@rainbow-me/rainbowkit';
import { WagmiProvider, http } from 'wagmi';
import {
  mainnet,
  bsc,
} from 'wagmi/chains';

import {
  QueryClientProvider,
  QueryClient,
} from "@tanstack/react-query";


import { Buffer } from 'buffer'
import Header from './Components/Header';
import Footer from './Components/Footer';




const CustomAvatar: AvatarComponent = ({ address, ensImage, size }) => {
  return ensImage ? (
    <img
      src={ensImage}
      width={size}
      height={size}
      style={{ borderRadius: 999 }}
      alt=''
    />
  ) : (
     <img style={{boxShadow : '0px 0px 8px -2px #000', borderRadius : '50px'}} src={img2} alt=''/>
  );
};
const myCustomTheme = {
  blurs: {
    modalOverlay: '...',
  },
  colors: {
    accentColor: '...',
    accentColorForeground: '...',
    actionButtonBorder: '...',
    actionButtonBorderMobile: '...',
    actionButtonSecondaryBackground: '...',
    closeButton: '...',
    closeButtonBackground: '#fff',
    connectButtonBackground: '#FF8C00',
    connectButtonBackgroundError: '...',
    connectButtonInnerBackground: '...',
    connectButtonText: '...',
    connectButtonTextError: '...',
    connectionIndicator: '...',
    downloadBottomCardBackground: '...',
    downloadTopCardBackground: '...',
    error: '...',
    generalBorder: '...',
    generalBorderDim: '...',
    menuItemBackground: '...',
    modalBackdrop: '#ffffff8c',
    modalBackground: '#fff',
    modalBorder: '#726f6f',
    modalText: '#000',
    modalTextDim: '...',
    modalTextSecondary: '...',
    profileAction: '...',
    profileActionHover: '...',
    profileForeground: '...',
    selectedOptionBorder: '...',
    standby: '...',
  },
  fonts: {
    body: '...',
  },
  radii: {
    actionButton: '...',
    connectButton: '...',
    menuButton: '...',
    modal: '16px',
    modalMobile: '16px',
  },
  shadows: {
    connectButton: '...',
    dialog: '0px 0px 12px -2px #000',
    profileDetailsAction: '...',
    selectedOption: '...',
    selectedWallet: '...',
    walletLogo: '...',
  },
};


const config = getDefaultConfig({
  appName: 'SHIELD App',
  projectId: '3503f54f4af9f3a448774f9a20a75584',
  chains: [bsc],
  ssr: false, // If your dApp uses server side rendering (SSR)
  transports: {
    [bsc.id]: http("https://bsc-dataseed1.binance.org"), // Public RPC for Binance Smart Chain
  },
}); 

const queryClient = new QueryClient();

// const { connectors } = getDefaultWallets({
//   appName: 'Shield Protocol',
//   chains,
// });

// Alternatively, use connectorsForWallets for custom connectors




// polyfill Buffer for client
if (!window.Buffer) {
  window.Buffer = Buffer
}
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
      <RainbowKitProvider avatar={CustomAvatar} theme={myCustomTheme}>
        {/* <Header /> */}
        <App />
        {/* <Footer /> */}
      </RainbowKitProvider>
      </QueryClientProvider>
      </WagmiProvider>
  </React.StrictMode>
);